export const MEDIA_FOCUS_EVENT = 'untangled:media-focus';
export function claimMedia(source: string) {
  window.dispatchEvent(new CustomEvent(MEDIA_FOCUS_EVENT, { detail: { source } }));
  document.querySelectorAll<HTMLMediaElement>('audio, video').forEach(media => {
    if (source !== 'music' || !media.hasAttribute('data-site-music')) media.pause();
  });
}
